import React from 'react';

export function parsePromotionAmount(value) {
  if (value === null || value === undefined || value === '') return null;
  const normalized = typeof value === 'string' ? value.replace(/,/g, '').trim() : value;
  const parsed = Number(normalized);
  return Number.isFinite(parsed) ? parsed : null;
}

export function getAppliedPromotion(paymentSummary, fallback = null) {
  const promotion = paymentSummary?.applied_promotion || fallback || null;
  const discount = parsePromotionAmount(
    paymentSummary?.promotion_discount_amount ?? promotion?.discount_amount
  );
  if (!promotion || discount === null || discount <= 0) {
    return null;
  }
  return {
    ...promotion,
    discount_amount: discount,
    base_amount: parsePromotionAmount(paymentSummary?.discount_base_amount ?? promotion?.base_amount),
    original_total: parsePromotionAmount(paymentSummary?.total_amount_before_discount),
    title: promotion?.title || '프로모션 할인',
  };
}

export function formatPromotionCurrency(value, currency = 'USD') {
  const amount = parsePromotionAmount(value);
  if (amount === null) return '-';
  return amount.toLocaleString('en-US', { style: 'currency', currency: currency || 'USD' });
}

export function PromotionDiscountRows({ paymentSummary, promotion, formatCurrency = formatPromotionCurrency }) {
  const appliedPromotion = getAppliedPromotion(paymentSummary, promotion);
  if (!appliedPromotion) return null;

  return (
    <div className="promotion-discount-summary">
      {appliedPromotion.original_total !== null && (
        <div className="payment-line promotion-original-total">
          <span className="label">할인 전 총 요금</span>
          <span className="amount">{formatCurrency(appliedPromotion.original_total)}</span>
        </div>
      )}
      <div className="payment-line promotion-discount-line">
        <span className="label">{appliedPromotion.title}</span>
        <span className="amount">-{formatCurrency(appliedPromotion.discount_amount)}</span>
      </div>
    </div>
  );
}
